/**
 * @generated SignedSource<<f2f68a0f1e802c525111acd58fea356f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditAfterDateTimeDoShowAnswerTreeConfigInput = {
  clientMutationId?: string | null | undefined;
  configId: string;
  newDateTime: string;
  rootNodeId: string;
};
export type AfterDateTimeDoShowAnswerTreeConfigForm_EditMutation$variables = {
  input: EditAfterDateTimeDoShowAnswerTreeConfigInput;
};
export type AfterDateTimeDoShowAnswerTreeConfigForm_EditMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly editAfterDateTimeDoShowAnswerTreeConfig: {
        readonly rootNode: {
          readonly " $fragmentSpreads": FragmentRefs<"ShowAnswerTreeConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type AfterDateTimeDoShowAnswerTreeConfigForm_EditMutation = {
  response: AfterDateTimeDoShowAnswerTreeConfigForm_EditMutation$data;
  variables: AfterDateTimeDoShowAnswerTreeConfigForm_EditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AfterDateTimeDoShowAnswerTreeConfigForm_EditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditAfterDateTimeDoShowAnswerTreeConfigPayload",
                "kind": "LinkedField",
                "name": "editAfterDateTimeDoShowAnswerTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ShowAnswerTreeConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AfterDateTimeDoShowAnswerTreeConfigForm_EditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditAfterDateTimeDoShowAnswerTreeConfigPayload",
                "kind": "LinkedField",
                "name": "editAfterDateTimeDoShowAnswerTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "showAnswerConfig",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTime",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "AfterDateTimeDoShowAnswerTreeConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "af8dc6c578a2cf57ba85560339515b71",
    "id": null,
    "metadata": {},
    "name": "AfterDateTimeDoShowAnswerTreeConfigForm_EditMutation",
    "operationKind": "mutation",
    "text": "mutation AfterDateTimeDoShowAnswerTreeConfigForm_EditMutation(\n  $input: EditAfterDateTimeDoShowAnswerTreeConfigInput!\n) {\n  Admin {\n    Tree {\n      editAfterDateTimeDoShowAnswerTreeConfig(input: $input) {\n        rootNode {\n          ...ShowAnswerTreeConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment on AfterDateTimeDoShowAnswerTreeConfig {\n  id\n  configType\n  dateTime\n}\n\nfragment AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment ShowAnswerTreeConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      showAnswerConfig {\n        __typename\n        configType\n        ... on AfterDateTimeDoShowAnswerTreeConfig {\n          dateTime\n        }\n        ...AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment\n        id\n      }\n    }\n  }\n  ...AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "2317610f185c5f71be425accca2f6161";

export default node;
